import { Expose, Transform } from 'class-transformer';
import { TEXTFIELD_BUTTON_ACTION_TYPES } from '@/models/enums/textfield-button-action-types.enum';
import cuid from 'cuid';

export class AiGeneratedTextFieldProps {
  @Expose()
  regenerateButtonLabel!: string;

  @Expose()
  placeholder!: string;

  @Expose()
  question!: string;

  @Expose()
  id!: number;

  @Expose()
  label!: string;

  @Expose({ name: 'elementType' })
  @Transform(({ value }) => `${value || 'field'}${cuid()}`)
  name!: string;

  @Expose()
  aiTextGeneratorSettings?: string;

  @Expose()
  actionButton?: {
    actions: TEXTFIELD_BUTTON_ACTION_TYPES;
    text: string;
  };

  @Expose()
  value!: string | null;
}
